"use strict";
const angular = require("angular");

const uiRouter = require("angular-ui-router");

import routes from "./files.routes";
import ProductAPI from "../permission/product/product.service";

export class FilesComponent {
  /*@ngInject*/
  constructor($location, ProductAPI) {
    "ngInject";

    this.location = $location;
    this.file = $location.search().file;
    this.params = this.file.split("-");
    this.files = [];
    this.notFound = false;
    var that = this;
    if (this.file && this.params.length === 3) {
      ProductAPI.getFileInput({
        inputId: parseInt(this.params[0]),
        demandId: parseInt(this.params[1]),
        createdBy: parseInt(this.params[2]),
      })
        .$promise.then((input) => {
          if (input) {
            that.files = input.filePaths;
          } else {
            that.notFound = true;
          }
          return;
        })
        .catch(() => {
          that.notFound = true;
        });
    } else {
      this.notFound = true;
    }
  }
}

export default angular
  .module("dalApp.files", [uiRouter, ProductAPI])
  .config(routes)
  .component("files", {
    template: require("./files.html"),
    controller: FilesComponent,
    controllerAs: "filesCtrl",
  }).name;



// WEBPACK FOOTER //
// ./client/app/files/files.component.js